/**
 * Formats the identical-LP count label shown next to multi-version products.
 *
 * @param {number} count the number of identical LPs (must be > 1).
 * @returns {string} e.g. "Totožných LP: 3".
 */
export function formatIdenticalLpCount(count: number): string {
	return `Totožných LP: ${count}`;
}
